// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__i483L"};